export default {
  planId: '', // url上取的planId
  planMeta: {
    planStatus:'',
    planType: '',
  },
  searchOfficerName: null,
  saveOfficerTotal: 0,
  officerList: [], //所有可分配的调查员
  allotList: [], // 已分配任务列表
  distributionListLoading:false,
};
